export default "__VITE_ASSET__CU18dlNb__"